import * as commonScripts from '../common'
const cmpAwards = {
  component: null,
  init: function (element) {
    const _ = this
    _.component = element
    commonScripts.util.animationTranslate(this)
    const form = _.component.querySelectorAll('.cmp-awards__form')
    if (form) {
      const strategyForm = _.component.querySelector('#strategy')
      const yearForm = _.component.querySelector('#year')
      if (location.search.includes('strategy-dropdown') && location.search.includes('year-dropdown')) {
        const rawParams = location.search.split('?strategy-dropdown=')
        const params = rawParams[1].split('&year-dropdown=')
        strategyForm.value = params[0]
        yearForm.value = params[1]
      }
    }
  }
}

export default cmpAwards
